import { render, staticRenderFns } from "./ItemTypeSelect.vue?vue&type=template&id=bcf4293c"
import script from "./ItemTypeSelect.vue?vue&type=script&lang=ts"
export * from "./ItemTypeSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports